
import * as React from 'react';
import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';
import '../styles/meeting_with_application.css';

function randomID(len) {
  let result = '';
  if (result) return result;
  var chars = '12345qwertyuiopasdfgh67890jklmnbvcxzMNBVCZXASDQWERTYHGFUIOLKJP', maxPos = chars.length, i;
  len = len || 5;
  for (i = 0; i < len; i++) {
    result += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return result;
}

const MeetingOne = () => {
  console.log("Access page")
  const roomID = "1";

  let myMeeting = async (element) => {
    const appID = 1879435348;
    const serverSecret = "603f771c214b851f4883bb62b194cd3c";
    const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(appID, serverSecret, roomID, randomID(5), randomID(5));
    const zp = ZegoUIKitPrebuilt.create(kitToken);
    zp.joinRoom({
      container: element,
      sharedLinks: [
        {
          name: 'Personal link',
          url: window.location.protocol + '//' + window.location.host + window.location.pathname + '?roomID=1',
        },
      ],
      scenario: {
        mode: ZegoUIKitPrebuilt.VideoConference,
      },
    });
  };

  return (
    <div>
      <canvas id="canvas-0" width="640" height="480" style={{ display: "none" }}></canvas>
      <div className="myCallContainer" ref={myMeeting} style={{ width: '100vw', height: '100vh' }}></div>
    </div >
  )
}

export default MeetingOne
